import { render, staticRenderFns } from "./CourseAndQuantity.vue?vue&type=template&id=5a98db2f&"
import script from "./CourseAndQuantity.vue?vue&type=script&lang=js&"
export * from "./CourseAndQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports